import React, { useState } from 'react';
import { Grid, TextField, Button, Paper, IconButton } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import _ from 'lodash';
import { SelectWithLabel } from '../../../utils/selectWithLabel';
import { editFlight } from '../../../store/dcs';
import { loadDepartures } from "../../../store/dcs";
// import checkPermissions from "../../../utils/checkPermissions";

const pad = (num) => {
  return Number(num) < 10 ? '0' + num : num
}

const formatFlightDate = (date) => {
  // NOTE // input: 2021-08-17, output: 17AUG2021
  let day = date.slice(8, 10)
  let month = date.slice(5, 7)
  let year = date.slice(0, 4)
  let monthsArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  month = monthsArr[Number(month) - 1]
  return `${day + month + year}`
}

const formatOutput = (flight, date) => {
  try {
    let output = {
      fltno: flight.FlightNumber,
      startDate: date,
      stopDate: date,
      originText: flight.Origin || '',
      destText: flight.Destination || '',
      departureTime: flight.Departure || '',
      arrivalTime: flight.Arrival || '',
      // NOTE // 4N flights do not have a flightId (Pretty sure that's just for Kalsoft)
      flightId: flight.fltid || '',
      comment: flight.comment || '',
      newStatus: 'Delayed',
      rfd: flight.RFD || ''
    }

    return output
  } catch (e) {
    console.error(e)
  }
}

// TODO // 10/1/21 DCS link, close/update flight dispatch, 
function EditDCSFlightModal(props) {
  const dispatch = useDispatch()
  const { flight, flightDate, modalClasses, closeModal, isMobile } = props
  const [page, setPage] = React.useState('Update')
  const [updateOutput, setUpdateOutput] = React.useState(formatOutput(flight, flightDate))
  const [error, setError] = useState('')
  // const airline = useSelector(state => state.entities.dcs.airline)
  // const userType = useSelector(state => state.entities.auth.userType)
  const editStatus = useSelector(state => state.entities.dcs.messageStatus)

  // NOTE // sets a single property on updateOutput
  const setOutput = (data, prop) => {
    let outputCopy = _.cloneDeep(updateOutput)
    outputCopy[prop] = data
    setUpdateOutput(outputCopy)
  }

  const updateFlight = () => {
    let outputCopy = _.cloneDeep(updateOutput)
    setError('')
    outputCopy.startDate = formatFlightDate(outputCopy.startDate)
    outputCopy.stopDate = formatFlightDate(outputCopy.stopDate)
    let payload = {editData: outputCopy, flightNumber: flight.FlightNumber, type: 'updateFlightTime'}
    setPage('Message Status')
    dispatch(editFlight(payload))
  }

  if (page === 'Update') {
    const statusChoices = [
      {label: 'Delayed', value: 'Delayed'},
      {label: 'Cancelled', value: 'Cancelled'}
    ]

    return (
      <Grid container justify="center" alignContent="center" style={{marginTop: '25%'}}>
        <Paper className={modalClasses.paper}>
          <Grid container justifyContent='center' item xs={12} style={{backgroundColor: 'rgb(63, 81, 181)', fontWeight: 'bold'}}>
            <Grid item xs={4}></Grid>
            <Grid container justifyContent="center" alignContent="flex-end" item xs={4}>Update Flight</Grid>
            <Grid item xs={3}></Grid>
            <Grid container justifyContent="center" item xs={1}>
              <IconButton variant="contained" size="small" style={{backgroundColor: '#eb494e', borderRadius: '0px', height: '21px', marginTop: '3px', border: '1px solid black'}} onClick={() => {closeModal()}}>
                X
              </IconButton>
            </Grid>
            <Grid container justifyContent="center" item xs={12}>
              <div>{`${flight.FlightNumber} ${flight.Origin}-${flight.Destination}`}</div>
            </Grid>
          </Grid>
          <Grid container id="flight-modal-update" justifyContent="center" >
              <Grid container justifyContent="center" item xs={6}>
                <TextField
                  id="start-date"
                  label="Start Date"
                  type="date"
                  defaultValue={flightDate}
                  style={{ width: '75%' }}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => {setOutput(e.target.value, 'startDate')}}
                />
              </Grid>
              <Grid container justifyContent="center" item xs={6}>
                <TextField
                  id="end-date"
                  label="End Date"
                  type="date"
                  defaultValue={flightDate}
                  style={{ width: '75%' }}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => {setOutput(e.target.value, 'stopDate')}}
                />
              </Grid>
              <Grid container justifyContent="center" item xs={6}>
                <TextField
                  id="ETD"
                  label="Estimated Time of Dep. (time is local)"
                  type="text"
                  placeholder='HH:MM'
                  defaultValue={updateOutput.departureTime}
                  style={{ width: '75%' }}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => {setOutput(e.target.value, 'departureTime')}}
                />
              </Grid>
              <Grid container justifyContent="center" item xs={6}>
                <TextField
                  id="ETA"
                  label="Estimated Time of Arrival (time is local)"
                  type="text"
                  placeholder='HH:MM'
                  defaultValue={updateOutput.arrivalTime}
                  style={{ width: '75%' }}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => {setOutput(e.target.value, 'arrivalTime')}}
                />
              </Grid>
              <Grid container justifyContent="center" item xs={6}>
                <SelectWithLabel defaultVal={updateOutput.newStatus} handleChange={(e) => {setOutput(e.target.value, 'newStatus')}} inputLabel={'New Status'} items={statusChoices}  customStyle={{width: '75%'}} />
              </Grid>
              <Grid container justifyContent="center" item xs={6}>
                <TextField
                  id="rfd"
                  label="Reason For Delay"
                  type="text"
                  defaultValue={updateOutput.rfd}
                  style={{ width: '75%' }}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => {setOutput(e.target.value, 'rfd')}}
                />
              </Grid>
              <Grid container justifyContent="center" item xs={12}>
                <TextField
                  id="comment"
                  label="Comment"
                  type="text"
                  defaultValue={updateOutput.comment}
                  style={{width: '87%'}}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => {setOutput(e.target.value, 'comment')}}
                />
              </Grid>
              <Grid container justifyContent="center" item xs={12} style={{color: 'red'}}>{error}</Grid>
            <Grid container justifyContent="center" item xs={12} style={{marginTop: '8px', marginBottom: '8px'}}>
              <Button variant="contained" style={{backgroundColor: '#03fc66', marginRight: '10px', fontWeight: 'bold'}} onClick={() => {updateFlight()}}>Submit</Button>
              <Button variant="contained" style={{backgroundColor: '#eb494e', fontWeight: 'bold'}} onClick={() => {closeModal()}}>Close</Button>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    )
  }

  else if (page === 'Message Status') {
    return (
      <Grid container justify="center" alignContent="center" style={{marginTop: '25%'}}>
        <Paper className={modalClasses.closeFlightSendingPaper}>
          <Grid container item xs={12} justify="center">
            <h3>{editStatus}</h3>
          </Grid>
          <Grid container item xs={12} justify="center">
            <Button variant="contained" onClick={() => {closeModal()}} style={{backgroundColor: '#eb494e', fontWeight: 'bold'}}>Close</Button>
          </Grid>
        </Paper>
      </Grid>
    )
  }
}

// export default withStyles(styles)(EditDCSFlightModal)
export default EditDCSFlightModal